import { HeroLayout } from '@change/ds-core-ui/HeroLayout';
import { Image } from '@change/ds-core-ui/Image';
import { Text } from '@change/ds-core-ui/Text';

import { useStarterQuoteContainer } from './hooks/useStarterQuoteContainer';

export const StarterQuoteContainer: React.FC = () => {
	const {
		data: { starterQuote, quoteImage, byLine },
	} = useStarterQuoteContainer();

	return (
		<HeroLayout
			media={<Image src={quoteImage} alt="" className="h-full w-full object-cover object-top" />}
			reverseMd
			variant="1/2"
		>
			<div className="bg-background-raised flex h-full flex-col justify-center gap-2 p-6 md:p-12">
				<Text as="p" variant="heading" size="small" fontWeight="light" className="italic">
					“{starterQuote}”
				</Text>
				<Text fontWeight="bold">{byLine}</Text>
			</div>
		</HeroLayout>
	);
};
